module.exports = __webpack_public_path__ + "img/7.049ccef6.svg";